export default __webpack_public_path__ + "static/media/delete-bin-outline-16px.18452604.svg";